import React from "react";
import { useCurrentApplication } from "../../../Context/CurrentApplicationContext/CurrentApplicationContext";

interface ConfiguredRound {
  roundNo: number;
  roundName: string;
  roundStyle: "mcq" | "descriptive" | "coding" | "mixed";
}

const ApplicationProcess: React.FC = () => {
  const { jobPost, rounds } = useCurrentApplication();

  if (!jobPost) {
    return null;
  }

  if (!rounds || rounds.length === 0) {
    return null;
  }

  const configuredRounds: ConfiguredRound[] = rounds.map((r) => {
    return {
      roundNo: r.roundNo,
      roundName: r.round.title,
      roundStyle: r.round.answerType.toLowerCase() as
        | "mcq"
        | "descriptive"
        | "coding"
        | "mixed",
    };
  });

  const getRoundDescription = (
    style: "mcq" | "descriptive" | "coding" | "mixed",
  ) => {
    switch (style) {
      case "mcq":
        return "Multiple choice answers";
      case "descriptive":
        return "Written answers";
      case "coding":
        return "Code-based answers";
      case "mixed":
        return "MCQ, written & coding answers";
      default:
        return "NA";
    }
  };

  return (
    <div className="job-posts-details__sidebar-process-card">
      <h4 className="job-posts-details__sidebar-process-title">
        Assessment Process
      </h4>
      <div className="job-posts-details__sidebar-process-list">
        {configuredRounds.map((r, index) => (
          <div className="job-posts-details__sidebar-process-item" key={index}>
            <div className="job-posts-details__sidebar-process-dots">
              <div className="job-posts-details__sidebar-process-dot job-posts-details__sidebar-process-dot--filled">
                {r.roundNo}
              </div>
              <div className="job-posts-details__sidebar-process-line" />
            </div>
            <div>
              <p className="job-posts-details__sidebar-process-name">
                {r.roundName}
              </p>
              <p className="job-posts-details__sidebar-process-desc">
                {getRoundDescription(r.roundStyle)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApplicationProcess;
